import React from "react";
import PropTypes from "prop-types";
import withTranslation from "../../../translation";
import styles from "./index.css";
import GermanVATIncluded from "./GermanVATIncluded";
import USSalesTax from "./USSalesTax";

const SubTotal = ({
  text,
  formatTranslation,
  countryCode,
  storeCode,
  USSalesTaxToggle
}) => (
  <div className={styles.subTotalContainer}>
    <h1>
      {formatTranslation("MiniBag.SubTotal.Title")}
      <USSalesTax
        countryCode={countryCode}
        USSalesTaxToggle={USSalesTaxToggle}
      />
    </h1>
    <div data-test-id="miniBagSubTotal">
      {text}
      <GermanVATIncluded storeCode={storeCode} />
    </div>
  </div>
);

SubTotal.defaultProps = {
  text: null
};

SubTotal.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  text: PropTypes.string,
  countryCode: PropTypes.string.isRequired,
  storeCode: PropTypes.string.isRequired,
  USSalesTaxToggle: PropTypes.bool.isRequired
};

export default withTranslation(SubTotal);



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/SubTotal/SubTotal.js